export const OUTBOUND_DIRECTION = 'outbound' as const;
export const INBOUND_DIRECTION = 'inbound' as const;
export const VALID_DIRECTIONS = [
  OUTBOUND_DIRECTION,
  INBOUND_DIRECTION,
] as const;
export const RETURN_TRIP_TYPE = 'return' as const;

export const MIN_MONTH_DAY = 1 as const;
export const MAX_MONTH_DAY = 31 as const;

export const MIN_MONTH = 1 as const;
export const MAX_MONTH = 12 as const;

export const CALENDAR_VIEW_MODE = 'calendar-view-mode' as const;
export const BAR_CHART_VIEW_MODE = 'bar-chart-view-mode' as const;
export const VALID_VIEW_MODES = [
  CALENDAR_VIEW_MODE,
  BAR_CHART_VIEW_MODE,
] as const;

export const FLIGHTS_TAB = 'flights-tab' as const;
export const HOTELS_DATE_PRICES_NETWORK_ERROR = 'network-error' as const;
export const HOTELS_DATE_PRICES_OTHER_ERROR = 'other-error' as const;
export const VALID_HOTELS_DATE_PRICES_ERRORS = [
  HOTELS_DATE_PRICES_NETWORK_ERROR,
  HOTELS_DATE_PRICES_OTHER_ERROR,
] as const;

export const PREVIOUS_SOURCE = 'PREV' as const;
export const NEXT_SOURCE = 'NEXT' as const;
export const SELECT_SOURCE = 'SELECT' as const;
export const GRID_SOURCE = 'GRID' as const;
export const CHECK_SOURCE = 'CHECK' as const;
export const AUTOMATED_SOURCE = 'AUTO' as const;
